import React, { memo } from "react";

const TestProgress = memo(function TestProgress({
  mockData,
  questions,
  currentQuestion,
  pending,
}) {

  const currentQuestionNumber = () => {
    return pending 
      ? currentQuestion + mockData?.q_count + 1
      : currentQuestion + 1;
  };

  const totalQuestions = () => {
    return pending  ? questions?.length + mockData?.q_count : questions.length;
  };

  console.log("currention---",currentQuestion);
  console.log("mockData.q_count",mockData?.q_count);
  console.log("questions?.length",questions?.length);
  console.log("currentQuestion + mockData?.q_count + 1",currentQuestion + mockData?.q_count + 1);

  return (
    <div className="item">
      <p>
        Question {currentQuestionNumber()} off {totalQuestions()}
          {/* Question {currentQuestion + mockData?.q_count + 1} off {questions?.length + mockData?.q_count} */}
      </p>
    </div>
  );
});

export default TestProgress;
